var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.ea0ca208d4c606f432966765b27dd9dd.svg#facebook';
                    var viewUrl = 'sprite.ea0ca208d4c606f432966765b27dd9dd.svg#view-facebook';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };